import React from 'react'

import {WorkflowPreReqFulfillScreenProps} from 'src/workflows/types'
import {StateSelectGQLContainer} from 'src/products/general/StateSelect/StateSelectGQLContainer'

type Props = WorkflowPreReqFulfillScreenProps

const StateSelectWorkflowContainer: React.FC<Props> = (props): JSX.Element => {
  const {onPreReqFulfilled: handleOnPreReqFulfilled} = props

  return <StateSelectGQLContainer onComplete={handleOnPreReqFulfilled} />
}

export {StateSelectWorkflowContainer}
